import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { MixedItemDistAction } from "@hooks/types";
import type { MixedItemDist } from "@memorang/types/src/tag";

interface MixedItemDistributionRequest {
	examId: string;
	action?: MixedItemDistAction;
	collectionId?: number;
}
export async function getMixedItemDistribution(
	request: MixedItemDistributionRequest,
): Promise<MixedItemDist> {
	// if (isMocked) {
	// 	return mockedMixedItemDistribution;
	// }
	const { data } = await authAxios.post(
		`${API_BASE_URL}/user-events-v2/v2/mixed-item-distribution`,
		request,
		{
			headers: {
				"Content-Type": "application/json",
			},
		},
	);

	return data.data;
}
